import React from 'react';
import { Accordion } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'; // Ensure Bootstrap CSS is imported
import '../../styles/brokerage.css'; // Import specific CSS for styling
import '../../styles/Fonts.css'; // Import font styling if needed

const faqData = [
  {
    question: 'What customs brokerage services do you provide?',
    answer: (
      <p className='poppins-regular text-start'>
        We provide comprehensive customs brokerage services including import/export documentation, 
        customs clearance, duty and tax calculation, and regulatory compliance management for all types of cargo.
      </p>
    ),
  },
  {
    question: 'How do you ensure compliance with customs regulations?',
    answer: (
      <p className='poppins-regular text-start'>
        Our expert team stays updated with the latest customs regulations and trade laws. We ensure 
        all documentation is accurate and complete, minimizing the risk of delays or penalties.
      </p>
    ),
  },
  {
    question: 'Do you handle both import and export brokerage?',
    answer: (
      <p className='poppins-regular text-start'>
        Yes, we manage both import and export customs brokerage services. Our team handles all 
        necessary paperwork, duty calculations, and regulatory requirements for seamless border crossings.
      </p>
    ),
  },
  {
    question: 'What documents do you need for customs clearance?',
    answer: (
      <p className='poppins-regular text-start'>
        Required documents typically include commercial invoices, packing lists, bills of lading, 
        certificates of origin, and any specific permits. Our team will guide you through the exact requirements.
      </p>
    ),
  },
];

const BrokerageFAQ = () => {
  return (
    <section id="faq" className="brokerage-faq-section">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-badge">HAVE QUESTIONS?</div>
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-description">
            Get answers to common questions about our customs brokerage services and processes.
          </p>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-8">
            <Accordion>
              {faqData.map((faq, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header>
                    <h5 className="mb-0">{faq.question}</h5>
                  </Accordion.Header>
                  <Accordion.Body>
                    {faq.answer}
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrokerageFAQ;
